/* eslint-disable prettier/prettier */
import { Mapa } from './../models/mapa.model';
import { Injectable } from '@angular/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ObjetivoEstrategico } from '../models/objetivo-estrategico.model';

@Injectable({
  providedIn: 'root',
})
export class MapaService {
  constructor(private http: HttpClient) {}
  index(): Observable<ObjetivoEstrategico[]> {
    return this.http.get<ObjetivoEstrategico[]>(environment.apiUrl + '/projetos/mapa');
  }
}
